import type { RetentionUnitEnum } from 'config/api/processingActivities/processingActivities.types';

import type { ProcessingActivityLegalBasis } from './processingActivityEditor.types';

export const PROCESSING_ACTIVITY_LEGAL_BASIS_OPTIONS: ProcessingActivityLegalBasis[] = [
  'gdpr_6_1_a',
  'gdpr_6_1_b',
  'gdpr_6_1_c',
  'gdpr_6_1_d',
  'gdpr_6_1_e',
  'gdpr_6_1_f',
];

export const PROCESSING_ROLE_OPTIONS = ['controller', 'processor'] as const;

export const PROCESSING_ACTIVITY_RETENTION_UNIT_OPTIONS: RetentionUnitEnum[] = ['days', 'months', 'years'];
